import gql from "graphql-tag";

export const GET_PAYMENTS_PAGINATED = gql`
  query getPaymentsPaginated($paginatedQueryInput: PaginatedQueryInput!) {
    getPaymentsPaginated(paginatedQueryInput: $paginatedQueryInput) {
      edges {
        id
        paymentNumber
        type
        source
        status
        invoice {
          id
          amountPaid
        }
        receivedDate
        payer
        amount
        invoicePrice
        tip
        paymentMethod
        paymentIntentId
      }
      pageInfo {
        endCursor
        hasNextPage
        numRecords
        offset
      }
    }
  }
`;
